import styled from 'styled-components'

export const LiveBlueIcon = styled.i`
    align-self: flex-start;
    line-height: 48px;
    font-family: 'Font Awesome 5 Pro';
    transition: all 0.3s;
    color: ${({ theme }) => theme['blue-500']};
    cursor: pointer;
    :hover {
        color: ${({ theme }) => theme['blue-400']};
    }
`

const Edit = styled(LiveBlueIcon)`
    content: 'far fa-edit';
`

const ManulaSendReportActionIcon = styled(LiveBlueIcon)`
    content: 'far fa-paper-plane';
`

const DuplicateModalIcon = styled(LiveBlueIcon)`
    content: 'far fa-paper-plane';
`

const StyledSendManualReport = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    span {
        color: ${({ theme }) => theme['blue-700']};
    }

    i {
        font-size: 14px;
        line-height: 32px;
        transition: all 0s;
        margin-right: 1rem;
        :hover {
            color: ${({ theme }) => theme['blue-500']};
        }
    }
`
const DuplicateForm = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    font-style: regular;
    font-size: 13px;
    line-height: 16px;
    align-items: left;
    vertical-align: Top;
    border-radius: 3px;

    :disabled {
        width: 100%;
    }

    /* .perspective {
        padding-top: 24px;
    } */

    /* label {
        padding-top: 24px;
    } */
`

export { Edit, ManulaSendReportActionIcon, StyledSendManualReport, DuplicateForm }
